import React, { useState,useEffect } from "react";

//import css
import "./Mid-Section-Pc.scss";

//import components
import InformationCardPc from "../../OverView/Pc-and-Large-Screens/Information-Card-Pc";
import TransactionsTable from "../../OverView/Pc-and-Large-Screens/Payments-Table";
import ProgressReportCard from "./Progress-Card";
import InvoicePendingTable from "./InvoicesPendingTable";

//import context
import { MyContext } from "../../../../tenantsDashContext.jsx";

//imports for user data
import { useSelector, useDispatch } from "react-redux";


const MidSectionPaymentsPc = () => {
    //data fetched from the store
  const dispatch = useDispatch();
  const { user, profile } = useSelector((state) => state.landlordslice);
  const token = user?.accessToken;
  const id = user?.user?.user_id;
  const property_id = user?.user?.propertyId;

  const [dataInCards, setDataInCards] = useState({});

  useEffect(() => {
    if (profile.totalHouses) {
      setDataInCards({
        paymentsMade: profile.paidInvoices?.total || 0,
        pendingInvoices: profile.unpaidInvoices?.total || 0,
        numberOfPaymentsMade: profile.totalPaidInvoices || 0,
        numberOfPendingInvoices: profile.totalUnpaidInvoices || 0,
        housesOccupied: profile.occupiedHouses || 0,
        totalHouses: profile.totalHouses || 0,
        arrearsReconciled: profile.totalArrearsPaid || 0,
        totalInvoiceAmount: profile.unpaidInvoices[0]?.amount || 0,
        totalPaymentsAmount: profile.paidInvoices[0]?.amount || 0,
      });
    }
    console.log("profile in phone", dataInCards);
  }, [profile]);


  const [tableToView, setTableToView] = useState("Invoices Paid");
  useEffect(() => { 

    console.log("table to view", tableToView);
  }, [tableToView]);

  

  return (
    <div className="mid-section-payments-pc">
      <div className="title">
        Your Reports
        <div className="description">Invoice and payment information</div>
      </div>

      <div className="cards-container">
        <InformationCardPc
          Title={"Invoices Paid"}
          percentage={((dataInCards?.paymentsMade / (dataInCards?.paymentsMade + dataInCards?.pendingInvoices )) * 100).toFixed(1) || 0}
          setTableToView={setTableToView}
          valueToSet={"transactions"}
          // cardData={[cardData1.water, cardData1.rent, cardData1.arrears, cardData1.garbage]}
        />
        <InformationCardPc
          Title={"Invoices Pending"}
          percentage={((dataInCards?.pendingInvoices / (dataInCards?.paymentsMade + dataInCards?.pendingInvoices )) * 100).toFixed(1) || 0}
          setTableToView={setTableToView}
          valueToSet={"invoices"}
        />
        <InformationCardPc
          Title={"Arrears"}
          percentage={((dataInCards?.arrearsReconciled / (dataInCards?.paymentsMade + dataInCards?.pendingInvoices )) * 100).toFixed(1) || 0}
          // setTableToView={setTableToView}
        />
        <InformationCardPc
          Title={"Other charges"}
          percentage={70}
          // setTableToView={setTableToView}
        />
      </div>
      <div className="transactions-and-progress">
        <div className="transactions-container">
          <div className="title">
            {tableToView === "transactions" && (
              <div className="description">Latest Transactions</div>
            )}
            {tableToView === "invoices" && (
              <div className="description">Pending Invoices</div>
            )}
          </div>

          <div className="transaction-history-table">
            {tableToView === "Invoices Paid" && <TransactionsTable />}
            {tableToView === "Invoices Pending" && <InvoicePendingTable />}
          </div>
        </div>
        <div className="progress-card-container">
          {/* <ProgressReportCard /> */}
        </div>
      </div>
    </div>
  );
};

export default MidSectionPaymentsPc;
